const CargillWhite = () => (
  <svg width="70" height="32" viewBox="0 0 186 85" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d={`M183.8 28.4C183.8 30.7 181.9 32.6 179.6 32.6C177.3 32.6 175.4 
      30.7 175.4 28.4C175.4 26.1 177.3 24.2 179.6 24.2C181.9 24.2 183.8 
      26.1 183.8 28.4ZM175.7 28.4C175.7 30.5 177.4 32.3 179.5 32.3C181.7 
      32.3 183.3 30.6 183.3 28.4C183.3 26.2 181.7 24.6 179.5 24.6C177.4 
      24.6 175.7 26.2 175.7 28.4ZM178 25.9H179.9C181 25.9 181.5 26.4 
      181.5 27.3C181.5 28.1 180.9 28.5 180.2 28.6L181.7 30.9H181.2L179.7 
      28.6H178.4V30.9H178V25.9ZM178.4 28.2H179.5C180.3 28.2 181.1 28.1 
      181.1 27.2C181.1 26.4 180.4 26.2 179.8 26.2H178.4V28.2Z`}
      fill="white"
    />
    <path
      d={`M54.1007 35C59.5007 35 62.7007 35.9 64.4007 38C65.3007 39.1 
        65.7007 40.6 65.8007 42.4C65.8007 43.4 65.7007 44.6 65.4007 
        45.8L61.7007 63.5C61.2007 66 60.9007 67.8 60.9007 69.4C60.9007 
        69.9 60.9007 70.4 61.0007 70.8C59.5007 70.8 52.1007 70.8 51.0007 
        70.8C51.0007 70.7 51.0007 70.6 51.0007 70.5C51.0007 69.8 51.0007 
        69 51.1007 68.2L51.2007 66.7H50.6007L50.4007 67C48.6007 69.9 44.5007 
        71.7 41.0007 71.7C38.1007 71.7 36.0007 71 34.8007 69.5C33.5007 67.9 
        33.2007 65.3 33.9007 61.9C35.3007 55.3 38.3007 52.5 45.8007 50.8L50.8007 
        49.7C53.8007 49 55.2007 47.7 55.7007 45.2C56.0007 43.8 55.8007 42.7 55.2007 
        42C54.6007 41.3 53.7007 41 52.5007 41C49.8007 41 48.4007 42.4 47.5007 45.8C46.6007 
        45.8 40.0007 45.8 38.5007 45.8C41.0007 36.5 49.3007 35 54.1007 35ZM54.0007 
        53.3C54.0007 53.3 53.8007 53.5 53.4007 53.6C52.8007 53.8 51.4007 54.1 50.5007 
        54.3C49.8007 54.5 49.1007 54.7 48.2007 55C46.0007 55.9 44.9007 57.4 44.3007 
        60.2C44.0007 61.8 44.2007 63.2 44.9007 64.1C45.4007 64.8 46.2007 65.1 47.2007 
        65.1C51.1007 65.1 52.3007 61.4 52.9007 58.5L54.0007 53.3Z`}
      fill="white"
    />
    <path
      d={`M90.0007 67.7C87.9007 65.1 87.5007 61 88.9007 53.7C92.1007 37.9 
      98.2007 35 103.401 35C105.901 35 109.701 35.9 110.101 40.3L110.201 
      41H110.901C110.901 41 111.801 36.9 111.901 36C112.901 36 120.201 36 
      121.701 36C121.301 37.7 114.501 70.8 114.501 70.8C112.801 79.1 107.401 
      83.3 97.6007 83.3C88.5007 83.3 87.2007 77.9 87.0007 76.3C86.9007 75.7 
      87.1007 73.8 87.1007 73.8C88.1007 73.8 95.3007 73.8 96.6007 73.8C96.6007 
      74.6 96.7007 75.9 97.0007 76.2C97.4007 76.7 97.7007 77.3 99.2007 
      77.3C101.201 77.3 103.101 76.7 104.101 72.2L105.701 64.4H104.901L104.701 
      64.8C102.801 68.2 99.1007 69.9 95.3007 69.9C92.9007 69.8 91.2007 69.1 90.0007 
      67.7ZM99.7007 53C98.6007 58.2 98.7007 60.2 99.7007 61.4C100.201 62 101.001 
      62.3 102.101 62.3C105.101 62.3 106.501 60.5 108.001 53.2C109.101 48 109.201 
      44.7 108.201 43.4C107.701 42.8 107.001 42.5 105.901 42.5C102.901 42.6 101.201 
      45.7 99.7007 53Z`}
      fill="white"
    />
    <path
      d={`M137.401 36C137.001 37.7 130.401 69.7 130.201 70.8C129.201 70.8 
      121.101 70.8 119.601 70.8C119.901 69.1 126.601 37.1 126.801 36C127.801 
      36 135.901 36 137.401 36Z`}
      fill="white"
    />
    <path
      d={`M156.801 24.4C156.401 26.1 147.401 69.7 147.201 70.9C146.201 70.9 
      138.101 70.9 136.601 70.9C137.001 69.2 146.001 25.6 146.201 24.4C147.201 
      24.4 155.301 24.4 156.801 24.4Z`}
      fill="white"
    />
    <path
      d={`M173.7 24.4C173.3 26.1 164.3 69.7 164.1 70.9C163.1 70.9 155 70.9 
      153.5 70.9C153.9 69.2 162.9 25.6 163.1 24.4C164.2 24.4 172.2 24.4 173.7 
      24.4Z`}
      fill="white"
    />
    <path
      d={`M91.5008 35C88.0008 35 83.9008 37.4 81.9008 41.3L81.7008 
      41.7H81.0008C81.0008 41.7 81.9008 37.2 82.2008 35.9C82.0008 
      35.9 81.7008 35.9 81.3008 35.9C80.2008 35.9 72.7008 35.9 
      71.2008 35.9C71.3008 36.3 71.3008 36.8 71.3008 37.3C71.3008 
      38.4 71.1008 39.7 70.9008 41.3C68.9008 50.8 65.1008 69.5 64.8008 
      70.8C66.3008 70.8 74.4008 70.8 75.4008 70.8C76.1008 67.5 79.4008 
      51.6 79.4008 51.6C80.4008 46.8 83.2008 44.6 88.3008 44.6C89.2008 
      44.6 89.9008 44.6 90.7008 44.8C90.9008 43.7 92.4008 36.5 92.7008 
      35.1C92.0008 35 91.5008 35 91.5008 35Z`}
      fill="white"
    />
    <path
      d={`M4.1003 69C1.5003 65.8 1.3003 59.8 3.7003 48.4C7.5003 30.2 
      12.9003 24.1 25.2003 24.1C30.1003 24.1 33.6003 25.3 35.5003 
      27.6C36.7003 29.1 37.3003 31.1 37.4003 33.7C37.4003 35.1 37.2003 
      36.7 36.9003 38.4C36.9003 38.4 36.6003 39.9 36.4003 40.8C35.4003 
      40.8 26.0003 40.8 26.0003 40.8C26.0003 40.8 26.8003 35.8 26.8003 
      34.7C26.8003 33.5 26.7003 32.8 26.3003 32.2C25.8003 31.6 25.1003 
      31 23.9003 31C19.3003 31 17.8003 35.4 15.2003 48C13.2003 57.8 
      12.4003 62.3 14.0003 64.3C14.6003 65 15.5003 65.4 16.7003 65.4C20.3003 
      65.4 21.7003 62.3 23.6003 53.7C24.6003 53.7 32.6003 53.7 34.1003 53.7C33.9003 
      54.7 33.5003 56.4 33.5003 56.4C31.3003 67.1 25.0003 72.5 14.9003 72.5C9.4003 
      72.5 6.0003 71.4 4.1003 69Z`}
      fill="white"
    />
    <path
      d={`M138.301 31.9C139.101 12.7 116.001 -1.70001 94.5008 2.79999C73.0008 
      7.29999 62.5008 26 59.8008 31.8H63.3008C68.0008 23.9 72.8008 17.7 80.9008 
      15.4C86.1008 13.9 90.1008 14.3 100.101 19.9C104.701 22.5 115.101 30.2 126.301 
      31.7C131.301 32.4 138.301 31.9 138.301 31.9Z`}
      fill="#008C44"
    />
  </svg>
);

export default CargillWhite;
